import React, { ReactNode } from 'react';
import './index.css';

interface StandardPageProps {
  children: ReactNode;
  title?: string;
  marginBottom?: number;
}

const StandardPage: React.FC<StandardPageProps> = ({ children, title, marginBottom = 20 }) => {
  return (
    <div className="standard-page">
      {title && (
        <h1 className="text-4xl font-bold text-gray-800 border-b-2 border-gray-200 pb-2" style={{ marginBottom }}>
          {title}
        </h1>
      )}
      <div className="content">{children}</div>
    </div>
  );
};

export default StandardPage;
